import { ZoneStatus, ZoneType } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createInventoryZoneAtom = createMutationAtomFactory(
  'inventory.createInventoryZone',
  (params: {
    facilityId: string;
    zoneCode: string;
    name: string;
    zoneType: ZoneType;
    status: ZoneStatus;
    parentZoneId?: string;
    capacityValue?: number;
    capacityUnit?: string;
    description?: string;
  }) => ({
    inventoryInventoryZoneCreate: {
      __args: {
        input: {
          facilityId: params.facilityId,
          zoneCode: params.zoneCode,
          name: params.name,
          zoneType: params.zoneType,
          status: params.status,
          parentZoneId: params.parentZoneId,
          capacityValue: params.capacityValue,
          capacityUnit: params.capacityUnit,
          description: params.description,
        },
      },
      id: true,
      facilityId: true,
      facility: {
        id: true,
        facilityName: true,
      },
      parentZoneId: true,
      zoneCode: true,
      name: true,
      zoneType: true,
      status: true,
      capacityValue: true,
      capacityUnit: true,
      description: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);

export const updateInventoryZoneAtom = createMutationAtomFactory(
  'inventory.updateInventoryZone',
  (params: {
    id: string;
    zoneCode?: string;
    name?: string;
    zoneType?: ZoneType;
    parentZoneId?: string | null;
    capacityValue?: number | null;
    capacityUnit?: string | null;
    description?: string | null;
  }) => ({
    inventoryInventoryZoneUpdate: {
      __args: {
        id: params.id,
        input: {
          zoneCode: params.zoneCode,
          name: params.name,
          zoneType: params.zoneType,
          parentZoneId: params.parentZoneId,
          capacityValue: params.capacityValue,
          capacityUnit: params.capacityUnit,
          description: params.description,
        },
      },
      id: true,
      facilityId: true,
      facility: {
        id: true,
        facilityName: true,
      },
      parentZoneId: true,
      zoneCode: true,
      name: true,
      zoneType: true,
      status: true,
      capacityValue: true,
      capacityUnit: true,
      description: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);

export const closeInventoryZoneAtom = createMutationAtomFactory(
  'inventory.closeInventoryZone',
  (params: { id: string }) => ({
    inventoryInventoryZoneClose: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);

export const archiveInventoryZoneAtom = createMutationAtomFactory(
  'inventory.archiveInventoryZone',
  (params: { id: string }) => ({
    inventoryInventoryZoneArchive: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
